import React from 'react'
import { Route } from 'react-router'
import { Redirect } from 'react-router-dom'
import { User } from 'utilities'
import PageWrapper from './PageWrapper'

const AdminRoute = (props: any) => {
  const { component: Component, ...rest } = props

  return (
    <Route
      {...rest}
      render={componentProps => (
        (User.isAuthenticated() && User.isAdmin())
          ? <PageWrapper><Component {...componentProps} /></PageWrapper>
          : <Redirect to={{ pathname: '/login', state: { from: componentProps.location } }} />
      )}
    />
  )
}

export default AdminRoute
